/*
  Celite — Ajándék Diatomit Poháralátét (gift with purchase)
  =========================================================
  Keeps the coaster in sync with the cart:
    • a Kőszőnyeg is in the cart  → the coaster is added automatically
    • the last Kőszőnyeg leaves   → the coaster is removed automatically
    • the shopper removes the gift themselves → we respect it and stop re-adding

  IMPORTANT — this script does NOT make the coaster free.
  The 0 Ft price comes from a native Shopify "Buy X get Y" automatic discount.
  If this file ever fails to load, the offer still works: the shopper adds the
  coaster themselves and the discount applies at checkout. Never move pricing in here.
*/
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 53129526345992; // Diatomit Poháralátét — SKU STONE-CST-GRE
  var MAT_SKU_PREFIX = 'STONE-MAT'; // Kőszőnyeg variants — STONE-MAT-GRE / STONE-MAT-WHI
  var GIFT_PROPERTIES = { 'Ajándék': 'A kőszőnyeged mellé jár' };
  var STATE_KEY = 'celite_gift_state'; // '' | 'added' | 'declined'

  var routes = (window.theme && window.theme.routes) || {};
  var ROOT_URL = routes.root_url || '/';
  var CART_URL = routes.cart_url || '/cart';
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';

  var running = false;
  var giftLineKey = null; // the gift's cart line key, as of the last check

  function state(value) {
    try {
      if (value === undefined) return sessionStorage.getItem(STATE_KEY) || '';
      if (value === '') sessionStorage.removeItem(STATE_KEY);
      else sessionStorage.setItem(STATE_KEY, value);
    } catch (e) {
      /* private mode — degrade to "always re-add" */
    }
    return value;
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // Tell the rest of the theme the cart moved, and hand it fresh drawer HTML to render.
  //
  // The theme's CartItems.onCartUpdate re-renders the drawer from `cart.sections[sectionId]`
  // and the header <cart-count> reads `cart.item_count`, both off the pubsub channel — so a
  // plain /cart.js object is not enough. It has no `sections` key, and reading into it throws
  // inside the subscriber, which then aborts everything queued after the publish.
  function redrawCart() {
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.sectionId : null;

    var sectionHtml = sectionId
      ? fetch(ROOT_URL + '?section_id=' + encodeURIComponent(sectionId))
          .then(function (r) {
            return r.text();
          })
          .catch(function () {
            return null;
          })
      : Promise.resolve(null);

    return Promise.all([getCart(), sectionHtml]).then(function (results) {
      var cart = results[0];
      var html = results[1];

      cart.sections = {};
      if (sectionId && html) cart.sections[sectionId] = html;

      var pubsub = window.theme && window.theme.pubsub;
      if (pubsub && pubsub.PUB_SUB_EVENTS) {
        try {
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'celite-gift', cart: cart });
        } catch (e) {
          console.warn('[celite-gift] a cartUpdate subscriber failed', e);
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    });
  }

  function sync() {
    if (running) return;
    running = true;

    getCart()
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var matKey = null;
        var gift = null;

        items.forEach(function (item) {
          if (item.sku && item.sku.indexOf(MAT_SKU_PREFIX) === 0 && !matKey) matKey = item.key;
          if (item.variant_id === GIFT_VARIANT_ID) gift = item;
        });

        giftLineKey = gift ? gift.key : null;

        // No mat in the cart — the gift has nothing to ride along with.
        // This also clears a previous decline, so re-adding a mat brings the gift back.
        if (!matKey) {
          state('');
          if (gift) return post(CHANGE_URL, { id: gift.key, quantity: 0 }).then(redrawCart);
          return null;
        }

        if (gift) {
          // One gift per order, no matter how many mats.
          if (gift.quantity !== 1) {
            return post(CHANGE_URL, { id: gift.key, quantity: 1 }).then(redrawCart);
          }
          return null;
        }

        if (state() === 'declined') return null;

        return post(ADD_URL, {
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: GIFT_PROPERTIES
        }).then(function (line) {
          // Record the new line key here rather than waiting for the next sync — the
          // 'cart:updated' the redraw triggers arrives while this run is still in flight,
          // so that sync bails out and the remove-click handler would have nothing to match.
          if (line && line.key) giftLineKey = line.key;
          return redrawCart();
        });
      })
      .catch(function (error) {
        // Never let the gift block a checkout.
        console.warn('[celite-gift]', error);
      })
      .then(function () {
        running = false;
      });
  }

  // If the shopper deletes the gift themselves, don't put it back. Catching the click is
  // the only unambiguous signal — a cart that has the mat but no gift looks identical
  // whether they removed it or the cart was just rebuilt, and Shopify's line keys are
  // deterministic, so they can't tell those two apart either.
  // Capture phase, so this runs before the theme's own remove handler.
  document.addEventListener(
    'click',
    function (event) {
      if (!giftLineKey || !event.target.closest) return;
      var link = event.target.closest('a[data-index]');
      if (link && link.getAttribute('data-index') === giftLineKey) state('declined');
    },
    true
  );

  // The theme fires 'ajaxProduct:added' from the product form / quick-add,
  // and 'cart:updated' from quantity changes inside the cart.
  document.addEventListener('ajaxProduct:added', sync);
  document.addEventListener('cart:updated', sync);

  // On mobile the product image fills the first screen, so the gift card under the
  // Add-to-cart button lands just below the fold. This badge sits on the image itself.
  // Only runs where the gift card rendered, i.e. on a Kőszőnyeg page.
  function mountMediaBadge() {
    if (!document.querySelector('.celite-gift')) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.celite-gift-media-badge')) return;

    var badge = document.createElement('span');
    badge.className = 'celite-gift-media-badge';
    badge.textContent = '🎁 + Ajándék poháralátét';
    gallery.appendChild(badge);
  }

  // The theme ships a sticky buy bar (<product-sticky-form>) but its IntersectionObserver
  // callback never fires on this store, so the card sits at opacity:0 forever — the page is
  // 6500px+ tall with a single Add-to-cart button at the top. This drives the theme's own
  // markup with a plain scroll listener instead of patching theme.js.
  function mountStickyBuyBar() {
    var sticky = document.querySelector('product-sticky-form');
    var card = sticky && sticky.firstElementChild;
    if (!card) return;

    var form = document.getElementById(sticky.getAttribute('form'));
    var footer = document.querySelector('.footer-group');
    if (!form || !footer) return;

    card.style.transition = 'opacity .25s ease, transform .25s ease';

    var shown = null;
    function update() {
      var pastForm = form.getBoundingClientRect().bottom < 0;
      var footerInView = footer.getBoundingClientRect().top < window.innerHeight;
      var show = pastForm && !footerInView;
      if (show === shown) return;
      shown = show;
      card.style.opacity = show ? '1' : '0';
      card.style.visibility = show ? 'visible' : 'hidden';
      card.style.transform = show ? 'translateY(0)' : 'translateY(15px)';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function start() {
    mountMediaBadge();
    mountStickyBuyBar();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
